import IKenoDraw from "../interfaces/IKenoDraw";
import ITicket from "../interfaces/ITicket";
import getTicketStatus from "./getTicketStatus";

/**
 *
 *
 * @param ticket the ticket whose status it being looked up
 * @param currentDraw the current draw being performed
 */
export default function getTicketStatusText(ticket: ITicket, currentDraw: IKenoDraw): string {
    const statusRemap: { [key: string]: string | undefined } = {
        completed: "Completed",
        live: "LIVE",
        upcoming: "Upcoming",
    };
    const status = getTicketStatus(ticket, currentDraw);
    return statusRemap[status] || (statusRemap.upcoming as string);
}



// WEBPACK FOOTER //
// ./src/utils/getTicketStatusText.ts